import { render, staticRenderFns } from "./dragSort.vue?vue&type=template&id=1603a1b4&scoped=true&"
import script from "./dragSort.vue?vue&type=script&lang=js&"
export * from "./dragSort.vue?vue&type=script&lang=js&"
import style0 from "./dragSort.vue?vue&type=style&index=0&id=1603a1b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1603a1b4",
  null
  
)

export default component.exports